import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import AppSection from './components/AppSection';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import WhatsAppButton from './components/WhatsAppButton';
import TripApp from './components/TripApp';
import AdminDashboard from './components/AdminDashboard';

export default function App() {
  useEffect(() => {
  let buffer = "";
  let timer = null;
  const onDown = (e) => {
    if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") return;
    buffer += e.key.toLowerCase();
    clearTimeout(timer);
    timer = setTimeout(() => { buffer = ""; }, 1000);
    if (buffer.endsWith("mgd")) {
      buffer = "";
      window.location.href = '/yk6524tshc';
    }
  };
  window.addEventListener('keydown', onDown);
  return () => window.removeEventListener('keydown', onDown);
}, []);
  return (
    <Routes>
      {/* דף הטיול - נתיב אבסולוטי */}
      <Route path="/app" element={<TripApp />} />

      {/* דשבורד ניהול — מוגן בסיסמה */}
      <Route path="/yk6524tshc" element={<AdminDashboard />} />

      {/* דף הבית - נתיב ראשי בלבד */}
      <Route path="/" element={
        <div className="overflow-x-hidden">
          <Navbar />
          <Hero />
          <About />
          <AppSection />
          <Gallery />
          <Testimonials />
          <Contact />
          <WhatsAppButton />
          <footer className="bg-brand-blue-dark py-6 text-center text-white/40 text-sm font-body font-light">
            © {new Date().getFullYear()} מגד שמיים — חופשת יוקרה יהודית מותאמת אישית
          </footer>
        </div>
      } />

      {/* טיפול במקרה של נתיב לא קיים - מחזיר לדף הבית */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}